import { CounsellorsConstants } from '../constants';
import { CounsellorsService } from '../../services/';
import { whitelabel } from '../reducers/whitelabel.reducer';
import Swal from 'sweetalert2';
import { alertActions } from './';
import { history } from '../../helpers';
import { constants } from '../../Constants';

export const CounsellorsActions = {
	fetchCounsellors,
	saveCounsellor,
	selectCounsellor,
	resetCounsellor
	
};

function fetchCounsellors() {
	return (dispatch) => {
		dispatch(request());

		CounsellorsService.fetchCounsellors().then(
			(counsellors) => {
				dispatch(success(counsellors));
			},
			(error) => dispatch(failure(error.toString()))
		);
	};
}

function saveCounsellor(data, id='') {
	return (dispatch) => {
		dispatch({ type: CounsellorsConstants.CREATECOUNSELLORS_REQUEST })
		CounsellorsService.saveCounsellors(data,id).then(			
			(whitelabel) => {
				Swal.fire({
					title: constants.SAAYA_HEALTH_TXT,
					text: constants.COUNSELLOR_CREATED_UPDATED_SUCCESS_TXT(id === ''?'created':'updated'),
					icon: constants.SUCCESS_TEXT,
					confirmButtonText: constants.OK_TXT
				});
				if (id !== '' )
					resetCounsellor();
				history.replace('/home');
				
			},
			(error) => {
				Swal.fire({
					title: constants.SAAYA_HEALTH_TXT,
					text: constants.COUNSELLOR_CREATED_UPDATED_FAILURE_TXT(id === ''?'created':'updated'),
					icon: constants.ERROR_TEXT,
					confirmButtonText: constants.OK_TXT
				});
				if(error && error.response && error.response.data && error.response.data.error){
					let  errors = error.response.data.error;
					let possible_errors = [
						'username',
						'password1',
						'password2',
						'non_field_errors',
						'email_address',
						'error',
						'0'
					];
					
					dispatch({ type: CounsellorsConstants.CREATECOUNSELLORS_FAILURE, data:errors.toString() });
				}
				
		
			}
					
		);
	};
}

function request() {
	return { type: CounsellorsConstants.GETCOUNSELLORS_REQUEST };
}

function success(counsellors) {
	if (counsellors.length > 0) {
		return { type: CounsellorsConstants.GETCOUNSELLORS_SUCCESS, counsellors };
	} else {
		const counsellors = [];
		return { type: CounsellorsConstants.GETCOUNSELLORS_FAILURE, counsellors };
	}
}

function failure(error) {
	return { type: CounsellorsConstants.GETCOUNSELLORS_FAILURE, error };
}


function selectCounsellor(id) {
	return (dispatch) => {
		dispatch({type: CounsellorsConstants.SELECTED_COUNSELLOR, id});
	};
}

function resetCounsellor() {
	return (dispatch) => {
		dispatch({type: CounsellorsConstants.RESET_COUNSELLOR});
	};
}


// WEBPACK FOOTER //
// ./src/store/actions/counsellors.actions.js